import React from 'react'
import SringharDarshan from "../components/darshans/Sringar";

const DailyDarshanGallery = () => {
    return (
        <SringharDarshan />
    )
}

export default DailyDarshanGallery
